
import {SELECTED_SO_CODE_JPNO } from "../constants/soCode";

export async function logoutUser({
  persistItemsReducer,
  loginReducer,
  dispatch,
  LogoutAction,
  constants,
  navigate,
  delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms)),
}) {
  let id_token = persistItemsReducer?.saveAuthParams?.id_token;
  await delay(100);
  const logoutUrl = (persistItemsReducer?.selectedSOData?.soCode === SELECTED_SO_CODE_JPNO) && location?.origin?.includes(".jp") ? 
  constants?.postLogoutUrl : 
  constants?.postLogoutUrl + persistItemsReducer?.selectedSOData?.soCode?.toLowerCase();
  
  dispatch(LogoutAction.logoutPersist(persistItemsReducer));

  // Reset for specific routes
  if (
    window.location.href.includes("/communityhomeview") ||
    window.location.href.includes("/connect") ||
    window.location.href.includes("/sendAGift")
  ) {
    dispatch(LogoutAction.logoutReset());
  }

  // Auth0 logout
  if (loginReducer?.getSOConfiguration?.loginModule?.provider === "Auth0") {
    // Remove session cookie and redirect to external site
    var d = new Date();
    d.setTime(d.getTime());
    const expires = "expires=" + d.toUTCString();
    document.cookie =
      constants?.so_NZLO?.nzSSOCookieName +
      "=;domain=worldvision.org.nz;path=/;" +
      expires;

    window.location.replace(
      "https://" +
      loginReducer?.getSOConfiguration?.loginModule?.domainName +
      "/v2/logout?federated=true&returnTo=" +
      encodeURI(constants?.so_NZLO?.app_url)
    );

  }
  // OneLogin logout
  else if (loginReducer?.getSOConfiguration?.loginModule?.provider === "OneLogin") {
    document.body.style.display = "none";
    if(localStorage.getItem("search")){
      console.log("inside logout 1")
        let pathname = localStorage.getItem("pathname");
        pathname = pathname.replace("/WVRetentionPortal", "")
        localStorage.setItem("redirectVia", "redirect_url")
        navigate(`/${localStorage.getItem("soname")}?redirect_url=${pathname}${localStorage.getItem("search")}`)
    }
  else{
    console.log("inside logout 2")
    let postlogoutredirecturl = loginReducer?.getSOConfiguration?.loginModule?.domainName +
      "/logout?post_logout_redirect_uri=" + logoutUrl
    if (id_token && id_token !== "undefined") {
      postlogoutredirecturl += `&id_token_hint=${id_token}`;
    }
    window.location.replace(postlogoutredirecturl);
  }
  }

  // Clear local storage/session
  localStorage.removeItem("tokenResp");
  localStorage.removeItem("persist:root");
  localStorage.removeItem("ssoCompleted");
}